export class UserProfileModel {
    firstName: string = '';
    lastName: string = '';
    email = '';
}


export class UserRegisterModel {
    id!: number
    // tab 1
    prefix!: number;
    prefixName!: string;
    firstName: string = '';
    lastName: string = '';
    birthday: string = '';

    day: string = null!;
    month: string = null!;
    year: string = null!;

    email: string = '';
    idCardNumber: string = '';
    behindIdCardNumber: string = '';
    phoneNumber: string = '';
    address: string = null!;
    moo!: number;
    soi: string = null!;
    road: string = null!;

    province: number = null!;

    district: number = null!;
    subDistrict: number = null!;
    zipcode: string = null!;
    country: number = 134;
    contactPhoneNumber!: string;
    fax!: number;

    contactStatus: boolean = true;

    contactAddress: string = null!;
    contactMoo!: number;
    contactSoi: string = null!;
    contactRoad: string = null!;
    contactProvince: number = null!;
    contactDistrict: number = null!;;
    contactSubDistrict: number = null!;
    contactZipcode: string = null!
    contactCountry: number = 134;
    contactPhone!: number;
    contactfax!: number;

    // tab 2
    username: string = '';
    password: string = '';
    passwordConfirm: string = '';
    questionForgetting: string = '';
    answerForgetting: string = '';

    idNo: string = ''

    //isAdmin: boolean = false
    
}

export interface ProvinceModel {
    proviceCode: string
    proviceId: number
    proviceName: string

}

export interface DistrictModel {
    districtId: number;
    districtCode: string;
    districtName: string;
}

export interface SubdistrictModel {
    subdistrictId: number;
    subdistrictName: string;
    subdistrictCode: string;
    zipCode: string;
}

export interface VerifyModel {
    firstName: string
    lastName: string
    dateOdBitrth: string
    idNumber: string
    idNumberBack: string
    isThaiD: string
}
export interface VerifyReturnModel {
    code: number
    desc: string 
}

export class Verify2Model {
    username!: string
    id!: number
}
export interface Register2Model {
    username: string,
    password: string,
    answer: string,
    qid: number
}

export class ForgetUserName{
    idNo: string = ''
    email: string = ''
}

export interface CheckDuplicateModel {
    code: number
    title: string 
    detail: string 
}
